import { render, staticRenderFns } from "./ChangeUserAccessDialog.vue?vue&type=template&id=64d7abb2&scoped=true"
import script from "./ChangeUserAccessDialog.vue?vue&type=script&lang=js"
export * from "./ChangeUserAccessDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeUserAccessDialog.vue?vue&type=style&index=0&id=64d7abb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7abb2",
  null
  
)

export default component.exports